<script setup lang="ts">
import ApplicationLogo from "@/Components/ApplicationLogo.vue";
</script>

<template>
    <div
        class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0"
    >
        <div>
            <ULink href="/">
                <ApplicationLogo class="h-20 fill-current text-gray-500" />
            </ULink>
        </div>

        <UCard
            class="w-full lg:max-w-md mt-6 p-4 shadow-md border-none"
        >
            <slot />
        </UCard>
    </div>
</template>
